export default __webpack_public_path__ + "static/media/Background_00256.d41458cb.png";